import { useEffect, useState } from "react"
import Navbar from "./Navbar"
import UserEditor from "../ConfigEditor/Users/UserEditor"
import RoleEditor from "../ConfigEditor/Roles/RoleEditor"
import ContextEditor from "../ConfigEditor/Contexts/ContextEditor"
import TierEditor from "../ConfigEditor/Tiers/TierEditor"
import VaultCredentialsEditor from "../ConfigEditor/VaultCreds/VaultCredentialsEditor"
import TemplateSettingsPage from "./TemplateSettingsPage"
import CommonConfigSettingsPage from "./CommonConfigSettingsPage"
import ModuleEditor from "../ConfigEditor/Modules/ModuleEditor"
import { Context, LoggedInUser } from "../../types/types"
import TagEditor from "../ConfigEditor/Tags/TagEditor"
import DemoConfigEditor from "../ConfigEditor/DemoConfig/DemoConfigEditor"
import BackendConfigEditor from "../ConfigEditor/BackendConfig/BackendConfigEditor"
import ServerEditor from "../ConfigEditor/Servers/ServerEditor"
import { getAccessibleSettingsPages, permCheck } from "../../util/permChecker"

export interface SettingsPageProps {
    context: Context,
    setContext: Function,
    user: LoggedInUser,
    navigate: Function,
    updateContextPicker: Function
}

function SettingsPage(props: SettingsPageProps) {

    const elements = ["Templates", "Common Configs", "Vault Credentials", "Users", "Roles", "Contexts", "Tiers", "Modules", "Tags", "Demo Config", "Config", "DB Servers"]
    type elType = typeof elements[number]

    const filteredElements: string[] = permCheck(props.user, "ADMIN", props.context.id) ? 
        elements : 
        getAccessibleSettingsPages(props.user, props.context.id)

    const [selected, setSelected] = useState<elType>(filteredElements[0])

    useEffect(() => {
        const newAccessiblePages = getAccessibleSettingsPages(props.user, props.context.id)
        if (newAccessiblePages.length === 0) {
            props.navigate("/tenants")
            return;
        }

        setSelected(newAccessiblePages[0])
    }, [props.context])


    const renderSetting = () => {
        switch(selected) {  
            case "Users":
                return (
                    <UserEditor/>
                )
            case "Roles":
                return (
                    <RoleEditor/>
                )
            case "Contexts":
                return (
                    <ContextEditor
                        context={props.context}
                        setContext={props.setContext}
                        updateContextPicker={props.updateContextPicker}
                    />
                )
            case "Tiers":
                return (
                    <TierEditor
                        context={props.context}
                    />
                )
            case "Vault Credentials":
                return (
                    <VaultCredentialsEditor
                        context={props.context}
                    />
                )
            case "Templates":
                return (
                    <TemplateSettingsPage
                        context={props.context}
                        user={props.user}
                    />
                )
            case "Common Configs":
                return (
                    <CommonConfigSettingsPage
                        context={props.context}
                    />
                )
            case "Modules":
                return (
                    <ModuleEditor
                        context={props.context}
                    />
                )
            case "Tags":
                return (
                    <TagEditor/>
                )
            case "Demo Config":
                return (
                    <DemoConfigEditor
                        context={props.context}
                    />
                )
            case "Config":
                return (
                    <BackendConfigEditor/>
                )
            case "DB Servers":
                return (
                    <ServerEditor context={props.context} />
                )
        }
    }

    return (
        <div style={{display: 'flex', flexDirection: 'column', gap: '20px', marginTop: '10px'}}>
            <Navbar
                elements={filteredElements}
                selectedEl={selected}
                setSelected={setSelected}
            />
            {renderSetting()}
        </div>
    )
}

export default SettingsPage